export default "__VITE_ASSET__e46e7955__"